module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Wolves.3968f4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Wolves.jpg
// module id = LukD
// module chunks = 0